module.exports = __webpack_public_path__ + "static/media/503.39d9e1cc.png";